import * as snippet from '@segment/snippet';
import { UUID } from '@trucksmarter/shared';

import env from '~/env.public';

export function loadSegmentScript() {
  const options = {
    apiKey: env.SEGMENT_WRITE_KEY,
    // Since next.js is essentially a single page app, the segment SDK does not
    // handle automatic page tracking. Page tracking is handled in
    // SegmentPageSyncer. Setting this `page` option to false avoid sending the
    // page event that is sent by default when a user does a full page
    // navigation.
    page: false,
  } satisfies snippet.Options;
  if (env.SEGMENT_UNMINIFIED) {
    return snippet.max(options);
  } else {
    return snippet.min(options);
  }
}

export function setSegmentUser(user: {
  id: UUID;
  name: string;
  email: string;
  phoneNumber: string;
}) {
  window.analytics?.identify(user.id, {
    name: user.name,
    email: user.email,
    phone: user.phoneNumber,
  });
}

/**
 * Sends an analytics event to Segment. Do not use this directly - use
 * useAnalytics.
 */
export function trackRaw(event: string, properties: Record<string, any>) {
  window.analytics?.track(event, properties);
}
